enum ModalButtonKey {
  ACCEPT = 'ACCEPT',
  ADD = 'ADD',
  BACK = 'BACK',
  CREATE = 'CREATE',
  IMPORT = 'IMPORT',
  INSERT = 'INSERT',
  NEXT = 'NEXT',
  LOADING = 'LOADING',
  SUBMIT = 'SUBMIT',
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE',
  APPLY = 'APPLY',
  DONE = 'DONE',
  CANCEL = 'CANCEL',
  CONTINUE = 'CONTINUE',
}

export default ModalButtonKey;
